import { render, staticRenderFns } from "./AddonDomainsView.vue?vue&type=template&id=23d56fdc&"
import script from "./AddonDomainsView.vue?vue&type=script&lang=js&"
export * from "./AddonDomainsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d56fdc')) {
      api.createRecord('23d56fdc', component.options)
    } else {
      api.reload('23d56fdc', component.options)
    }
    module.hot.accept("./AddonDomainsView.vue?vue&type=template&id=23d56fdc&", function () {
      api.rerender('23d56fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/domains/AddonDomainsView.vue"
export default component.exports